import { AxiosResponse } from 'axios';
import { KeyValue } from '@/main/models/common';
import { Result } from '@/main/models/common/resultResponse';
import { CompanyTypeRequest } from '@/main/models/request/companyTypeRequest';

export abstract class ICompanyTypeApi {
  abstract getDomain(
    request: CompanyTypeRequest | null
  ): Promise<AxiosResponse<Result<KeyValue[]>>>;
  abstract getDomainPublic(): Promise<AxiosResponse<Result<KeyValue[]>>>;
}
